import classNames from 'classnames';
import { useState } from 'react';
import { Button, FlexContainer, Txt, Icon } from 'components';
import { useDataActions, useTenancy } from 'state';
import styles from './NotCreated.module.scss';

/**
 * NotCreated
 *
 * @return {JSX.Element}
 */
const NotCreated = ({ className }) => {
  const [isLoading, setIsLoading] = useState(false);
  const storageActions = useDataActions();
  const tenancyDoc = useTenancy();
  const tenancyData = tenancyDoc.data;

  const handleCreateAndSendAgreement = async () => {
    console.log('Create and send agreement', tenancyData.tenancyUid);
    setIsLoading(true);
    await storageActions.tenancy.createAndSendAgreement(tenancyDoc);
    setIsLoading(false);
  };

  return (
    <FlexContainer
      className={classNames(
        styles.NotCreated,
        className,
        NotCreated.displayName
      )}
      column
      gap
    >
      <Txt bold>⚠️Legally required</Txt>
      <Txt regular>
        A tenancy agreement is a document that contains all of the important
        tenancy information as well as the legal obligations of the landlord,
        tenants and any guarantors. An agreement must be signed before the start
        of a tenancy.
      </Txt>
      <Txt regular>
        If you have any questions or concerns please seek the advice of a
        qualified solicitor.
      </Txt>
      <Txt regular>View a demo of this agreement below.</Txt>
      <a
        className={styles.ButtonLink}
        href={tenancyData.agreement.previewUrl}
        target="_blank"
        rel="noreferrer"
      >
        <Button flex reverse>
          <FlexContainer flex spaceBetween>
            <Txt>View the demo agreement</Txt>
            <Icon name="goto" />
          </FlexContainer>
        </Button>
      </a>
      <Txt regular>
        Propa creates an agreement using data from this tenancy and property.
        This is then sent to all parties to be reviewed and digitally signed.
      </Txt>
      <Txt regular>
        Its important at this point that the contact details for all parties are
        correct.
      </Txt>
      <Button
        flex
        success
        onClick={handleCreateAndSendAgreement}
        disabled={isLoading}
      >
        Create and Send Agreement
      </Button>
    </FlexContainer>
  );
};

NotCreated.displayName = 'NotCreated';

export default NotCreated;
